/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_GenerateInputs */



/**
* | output |
* | --- |
* | "Prepare" |
*
* @param {Meeting_Prep_GenerateInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_generate = /** @type {((inputs?: Meeting_Prep_GenerateInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_GenerateInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voorbereiding maken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer la préparation")
	return /** @type {LocalizedString} */ ("Prepare")
});